export default function sortPriorityFiats (unsortedFiatList) {
  const fiatPriority = { USD: 1, EUR: 2, GBP: 3 };
  const lowestPriority = Number.MAX_SAFE_INTEGER;

  return unsortedFiatList.sort((fiatA, fiatB) => {
    const first = (fiatA.code in fiatPriority) ? fiatPriority[fiatA.code] : lowestPriority;
    const second = (fiatB.code in fiatPriority) ? fiatPriority[fiatB.code] : lowestPriority;

    if (first < second) {
      return -1;
    } else if (first > second) {
      return 1;
    }
    return fiatA.code.localeCompare(fiatB.code);
  });
}
